import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleMaintenanceRecordCategoryEnum } from '../enums/vehicle-maintenance-record-category.enum';
import { VehicleMaintenanceStatusEnum } from '../enums/vehicle-maintenance-status.enum';

import { VehicleMaintenanceLinksDto } from './vehicle-maintenance-links.dto';

/**
 * Vehicle maintenance DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE_MAINTENANCE)
export class VehicleMaintenanceSearchDto extends BaseSearchDto {
  code!: string;
  documentNumber!: string;
  externalReference?: string | null;
  status!: VehicleMaintenanceStatusEnum;
  recordCategory!: VehicleMaintenanceRecordCategoryEnum;
  startsAt?: Date | null;
  endsAt?: Date | null;
  vehicleVin!: string;
  vehicleLicensePlate?: string | null;
  rentalAgreementDocumentNumber?: string | null;
  supplierId?: number | null;
  supplier?: SupplierSearchDto | null;
  supplierContactShortName?: string | null;
  estimatedCost?: number | null;
  serviceCenter?: string | null;
  links?: VehicleMaintenanceLinksDto | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
  computedTotalNet?: number | null;
  computedTotalTax?: number | null;
  computedTotalGross?: number | null;
}
